import React from 'react';
import TwitterIcon from '../../../01-atoms/images/icons/TwitterIcon.component';
import FacebookIcon from '../../../01-atoms/images/icons/FacebookIcon.component';
import InstagramIcon from '../../../01-atoms/images/icons/InstagramIcon.component';
import bem from '../../../_utils/bem';

var SocialMenu = function SocialMenu() {
  var block = 'social-menu';
  return /*#__PURE__*/React.createElement("ul", {
    className: bem(block)
  }, /*#__PURE__*/React.createElement("li", {
    className: bem(block, 'item')
  }, /*#__PURE__*/React.createElement("a", {
    className: bem(block, 'link'),
    href: "#"
  }, /*#__PURE__*/React.createElement(TwitterIcon, {
    block: block
  }), /*#__PURE__*/React.createElement("span", {
    className: bem(block, 'text')
  }, "Twitter"))), /*#__PURE__*/React.createElement("li", {
    className: bem(block, 'item')
  }, /*#__PURE__*/React.createElement("a", {
    className: bem(block, 'link'),
    href: "#"
  }, /*#__PURE__*/React.createElement(FacebookIcon, {
    block: block
  }), /*#__PURE__*/React.createElement("span", {
    className: bem(block, 'text')
  }, "Facebook"))), /*#__PURE__*/React.createElement("li", {
    className: bem(block, 'item')
  }, /*#__PURE__*/React.createElement("a", {
    className: bem(block, 'link'),
    href: "#"
  }, /*#__PURE__*/React.createElement(InstagramIcon, {
    block: block
  }), /*#__PURE__*/React.createElement("span", {
    className: bem(block, 'text')
  }, "Instagram"))));
};

export default SocialMenu;